<template>
	<b-modal v-model="isActive" has-modal-card @close="closeModal()" :can-cancel="false">
		<div class="modal-card modalCardContainer"
			style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
			<header class="modal-card-head" style="background-color: rgba(40, 40, 40, 1); color: white">
				Neue Ab-/Anwesenheit erfassen
			</header>
			<section class="modal-card-body" style="padding: 0.5em; color: #313131">
				<div class="is-flex is-flex-direction-column">
					<div class="block mb-1 mt-2">
						<b-field
							:message="($v.radioStatus.$invalid) ? 'Bitte geben Sie an, ob es sich um eine Ab- oder um eine Anwesenheit handelt!' : ''"
							:type="($v.radioStatus.$invalid) ? 'is-danger' : 'is-success'">
							<template #label>
								<div class="align-content-center" style="display: inline-flex">
									<p>Eintragstyp</p>
								</div>
							</template>
							<b-radio v-model="radioStatus" name="status" class="mr-4" :native-value="1">
								Abwesenheit
							</b-radio>
							<b-radio v-model="radioStatus" name="status" class="mr-4" :native-value="-1">
								Anwesenheit
							</b-radio>
						</b-field>
					</div>
					<b-field expanded
						:message="($v.attendanceStartDate.$invalid) ? 'Bitte geben Sie ein Startdatum an! Das Startdatum muss vor dem Enddatum liegen!' : ''"
						:type="($v.attendanceStartDate.$invalid) ? 'is-danger' : 'is-success'">
						<template #label>
							<div class="align-content-center" style="display: inline-flex">
								<p>Beginn des Eintrags</p>
							</div>
						</template>
						<b-datepicker :first-day-of-week=1 expanded :date-formatter="dateFormatter" trap-focus editable
							locale="de-DE" v-model="attendanceStartDate">
						</b-datepicker>
					</b-field>
					<b-field expanded
						:message="($v.attendanceEndDate.$invalid) ? 'Bitte geben Sie ein Enddatum an! Das Enddatum muss nach dem Startdatum liegen!' : ''"
						:type="($v.attendanceEndDate.$invalid) ? 'is-danger' : 'is-success'">

						<template #label>
							<div class="align-content-center" style="display: inline-flex">
								<p>Ende des Eintrags</p>
							</div>
						</template>
						<b-datepicker :first-day-of-week=1 expanded :date-formatter="dateFormatter" trap-focus editable
							locale="de-DE" v-model="attendanceEndDate">
						</b-datepicker>
					</b-field>
					<div v-if="radioStatus == 1">
						<BaseSearchableSelect :data-options="absenceReasons" :editObject="attendanceReason"
							:enable-validation="true" validationMessage="Bitte wählen Sie einen Abwesenheitsgrund aus!"
							label-text="Abwesenheitsgrund" :enable-order="true"
							:select="(object) => (attendanceReason = object)" />
					</div>
					<div v-if="radioStatus == -1">
						<BaseSearchableSelect :data-options="presenceReasons" :editObject="attendanceReason"
							:enable-validation="true" validationMessage="Bitte wählen Sie einen Anwesenheitsgrund aus!"
							label-text="Anwesenheitsgrund" :enable-order="true"
							:select="(object) => (attendanceReason = object)" />
					</div>
					<div>
						<b-field expanded>
							<template #label>
								<div class="align-content-center" style="display: inline-flex">
									<p>Anmerkungen</p>
								</div>
							</template>
							<b-input type="text" v-model="attendanceHint" />
						</b-field>
					</div>
				</div>
			</section>
			<footer class="modal-card-foot footerContainer" style=" color: white">
				<b-button @click="closeModal()" type="is-primary">
					Abbrechen
				</b-button>
				<b-button @click="saveClientAttendance()" type="is-primary" v-bind:loading="isLoading"
					v-bind:disabled="$v.radioStatus.$invalid || $v.attendanceStartDate.$invalid || $v.attendanceEndDate.$invalid || $v.attendanceReason.$invalid">
					Speichern
				</b-button>
			</footer>
		</div>
	</b-modal>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import { negativeFeedBack, positiveFeedBack } from "@/lib/Toast";
import Parse from "parse/dist/parse.min.js";
import BaseSearchableSelect from "@/components/helper/SearchableSelects/BaseSearchableSelect.vue"

export default {
	name: "AddClientAttendance",
	components: { BaseSearchableSelect },
	props: ["value"],
	data() {
		return {
			isLoading: false,
			radioStatus: 0,
			attendanceStartDate: undefined,
			attendanceEndDate: undefined,
			attendanceReason: undefined,
			attendanceHint: ""
		};
	},
	validations: {
		radioStatus: {
			validator: function (value) {
				return value == 1 || value == -1
			}
		},
		attendanceReason: {
			required
		},
		attendanceStartDate: {
			required,
			validator: function (value) {
				if (this.attendanceEndDate) {
					return value.getTime() <= this.attendanceEndDate.getTime()
				}
				return false
			}
		},
		attendanceEndDate: {
			required,
			validator: function (value) {
				if (this.attendanceStartDate) {
					return value.getTime() >= this.attendanceStartDate.getTime()
				}
				return false
			}
		},
	},
	watch: {},
	mounted() { },
	computed: {
		...mapGetters({
			absenceReasons: "absence/getData",
			presenceReasons: "presence/getData",
			focusedClient: "clients/getFocusedClient",
		}),
		isActive: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			},
		},
	},
	methods: {
		dateFormatter(dt) {
			return dt.toLocaleDateString("de-DE", {
				year: "numeric",
				month: "2-digit",
				day: "2-digit",
			});
		},
		closeModal() {
			this.isLoading = false;
			this.isActive = false;
			this.radioStatus = 0;
			this.attendanceStartDate = undefined;
			this.attendanceEndDate = undefined;
			this.attendanceReason = undefined;
			this.attendanceHint = "";
		},
		async saveClientAttendance() {
			this.isLoading = true;

			let isAbsence = this.radioStatus == 1 ? true : false
			let isPresence = this.radioStatus == -1 ? true : false

			const parseObject = Parse.Object.extend("ClientAttendance")
			const dataObject = new parseObject()

			dataObject.set("isAbsence", isAbsence)
			dataObject.set("isPresence", isPresence)
			dataObject.set("startDate", this.attendanceStartDate)
			dataObject.set("endDate", this.attendanceEndDate)

			if (isAbsence){
				dataObject.set("attendancePresence", undefined)
				dataObject.set("attendanceAbsence", this.attendanceReason)
			} else {
				dataObject.set("attendancePresence", this.attendanceReason)
				dataObject.set("attendanceAbsence", undefined)
			}
			
			dataObject.set("hint", this.attendanceHint)
			dataObject.set("client", this.focusedClient)

			let author = Parse.User.current();
			
			dataObject.set("author", author)
			dataObject.set("deleted", false)
			dataObject.set("storno", false)
			dataObject.set("stornoReason", "")
						
			await dataObject.save();

			this.isLoading = false;
			this.closeModal()
			await positiveFeedBack("Eintrag angelegt!")
		},
	}
}

</script>



<style scoped></style>